<template><button v-bind="$attrs" type="button" class="dropdown-item" :disabled="disabled" @click="click"><slot /></button></template>
<script>
export default {
    name: "SbDropdownItemButton",
    emits: ["click"],
    inheritAttrs: false,
    inject: { sbDropdown: { default: null } },
    props: { disabled: { type: Boolean, default: false } },
    methods: { click(event) { this.$emit("click", event); this.sbDropdown?.select(); } },
};
</script>
